import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { VehicleService } from '../../services/vehicle.service';
import { timeInterval } from 'rxjs/operators';
import { UnitService } from 'src/app/units/services/unit.service';
import { DataCollectionCreate } from '../content-panel-vehicles/models/data-collection-create.model';
import { PanelVehicleCommunicationService } from '../content-panel-vehicles/service/panel-vehicle-communication.service';

@Component({
  selector: 'app-panel-vehicles',
  templateUrl: './panel-vehicles.component.html',
  styleUrls: ['./panel-vehicles.component.scss'],
})
export class PanelVehiclesComponent implements OnInit {
  listTable: number = 0;
  displayGroup: boolean = false;
  newVehicleService: UnitService;

  constructor(
    private vehicleService: VehicleService,
    private _newVehicleService: UnitService,
    private _panelVehicleCommunicationService: PanelVehicleCommunicationService
  ) {
    this.vehicleService.listTable = 1;
    this.listTable = this.vehicleService.listTable;
    this.newVehicleService = _newVehicleService;
    this.vehicleService.clickListTable.subscribe((res) => {
      // //console.log("cambio de tabla panel", res);
      this.listTable = this.vehicleService.listTable;
    });
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {
    // //console.log('OnDestroy .......');
    this.vehicleService.listTable = -1;
  }
  onHideDisplayGroup(event: boolean) {
    this.displayGroup = event;
  }
  eventDisplayGroup(event: boolean) {
    // //console.log('desde panel',event);
    this.displayGroup = event;
  }

  onConfirmRender(dataCollectionCreate: DataCollectionCreate) {
    this._panelVehicleCommunicationService.emitEventDataCollectionCreate(
      dataCollectionCreate
    );
    this.newVehicleService.reloadUnits();
  }
}
